import React from "react";
import { Typography } from "antd";

const { Title } = Typography;

function NoPage() {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Title level={1}>404</Title>
      <div className="divider-small"></div>
      <Title level={4}>This page does not exists</Title>
    </div>
  );
}

export default NoPage;
